import {
  Component,
  OnInit
} from '@angular/core';

import {UserService} from '../../services/user.service';
import {TranslateService} from '@ngx-translate/core';
import {LanguageService} from "../../services/language.service";

@Component({
  selector: 'nestas-lang',
  templateUrl: './lang.component.html',
  styleUrls: ['./lang.component.scss']
})
export class NestasLangComponent implements OnInit {

  langs:string[];

  constructor(private _user:UserService, public translate:TranslateService, public languageService:LanguageService) {

  }

  ngOnInit() {
    this.langs = this.languageService.getSupportedLanguages();
  }

  setLang(lang) {
    document.documentElement.setAttribute("lang", lang);
    this.translate.use(lang);
    if (this.isLoggedIn()) {
      this._user.changeMyLang(lang).subscribe();
    }
  }

  isLoggedIn() {
    return this._user.isLoggedIn();
  }

  isAdmin() {
    return this._user.isAdmin();
  }
}
